import {
    isFunction,
    isObject,
    isString,
    classOf
} from "./main";

export function getWindowSize() {
    let elem = document.compatMode == "CSS1Compat" ? document.documentElement : document.body;
    return {
        width: elem.clientWidth,
        height: elem.clientHeight
    };
}

export function getScroll() {
    let x = 0;
    let y = 0;
    let html = document.getElementsByTagName("html")[0];
    let body = document.body;

    if ( window.pageXOffset !== undefined ) {
        y = pageYOffset;
        x = pageXOffset;
    } else {
        y = (html.scrollTop || body && body.scrollTop || 0) - html.clientTop;
        x = (html.scrollLeft || body && body.scrollLeft || 0) - html.clientLeft;
    }

    return {
        top: y,
        left: x
    };
}

export function getMousePoint(e) {
    return getTouchPoint(e);
}

export function getTouchPoint(e) {
    if ( e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0 ) {
        return {
            x: e.originalEvent.touches[0].pageX,
            y: e.originalEvent.touches[0].pageY
        };
    }
    else if ( e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length > 0 ) {
        return {
            x: e.originalEvent.changedTouches[0].pageX,
            y: e.originalEvent.changedTouches[0].pageY
        };
    }
    else {
        return {
            x: e.pageX || e.clientX || e.originalEvent && e.originalEvent.clientX,
            y: e.pageY || e.clientY || e.originalEvent && e.originalEvent.clientY
        };
    }
}

export function initBox(params, keyFrom, keyTo) {
    if ( !keyTo ) {
        keyTo = "box";
    }
    if ( !keyFrom ) {
        keyFrom = "box";
    }

    if ( !isObject(params) ) {
        params = {};
    }

    let $box;
    let box;
    // { box: "selector" }
    if ( isString(params[keyFrom]) ) {
        $box = window.$(params[keyFrom]);
        box = $box.get(0);
    }
    // { $box: "selector" }
    else if ( isString(params["$" + keyFrom]) ) {
        $box = window.$(params["$" + keyFrom]);
        box = $box.get(0);
    }
    // { box: jQueryObject }
    else if ( params[keyFrom] instanceof window.$ ) {
        $box = params[keyFrom];
        box = $box.get(0);
    }
    // { $box: jQueryObject }
    else if ( params["$" + keyFrom] instanceof window.$ ) {
        $box = params["$" + keyFrom];
        box = $box.get(0);
    }
    // { $box: Element or str }
    else if ( params["$" + keyFrom] ) {
        $box = window.$(params["$" + keyFrom]);
        box = $box.get(0);
    }
    // { box: Element or str }
    else if ( params[keyFrom] ) {
        $box = window.$(params[keyFrom]);
        box = $box.get(0);
    }

    if ( !(box instanceof Element) ) {
        throw new Error("Box is not are DOMElement");
    }

    this[keyTo] = box;
    this["$" + keyTo] = $box;
}

export const htmlCodes = [
    { name: "&nbsp;",code: "&#39;",value: "'" },
    { name: "&nbsp;",code: "&#160;",value: " " },
    { name: "&pound;",code: "&#163;",value: "£" },
    { name: "&euro;",code: "&#8364;",value: "€" },
    { name: "&para;",code: "&#182;",value: "¶" },
    { name: "&sect;",code: "&#167;",value: "§" },
    { name: "&copy;",code: "&#169;",value: "©" },
    { name: "&reg;",code: "&#174;",value: "®" },
    { name: "&trade;",code: "&#8482;",value: "™" },
    { name: "&deg;",code: "&#176;",value: "°" },
    { name: "&plusmn;",code: "&#177;",value: "±" },
    { name: "&frac14;",code: "&#188;",value: "¼" },
    { name: "&frac12;",code: "&#189;",value: "½" },
    { name: "&frac34;",code: "&#190;",value: "¾" },
    { name: "&times;",code: "&#215;",value: "×" },
    { name: "&divide;",code: "&#247;",value: "÷" },
    { name: "&fnof;",code: "&#402;",value: "ƒ" },
    { name: "&Alpha;",code: "&#913;",value: "Α" },
    { name: "&Beta;",code: "&#914;",value: "Β" },
    { name: "&Gamma;",code: "&#915;",value: "Γ" },
    { name: "&Delta;",code: "&#916;",value: "Δ" },
    { name: "&Epsilon;",code: "&#917;",value: "Ε" },
    { name: "&Zeta;",code: "&#918;",value: "Ζ" },
    { name: "&Eta;",code: "&#919;",value: "Η" },
    { name: "&Theta;",code: "&#920;",value: "Θ" },
    { name: "&Iota;",code: "&#921;",value: "Ι" },
    { name: "&Kappa;",code: "&#922;",value: "Κ" },
    { name: "&Lambda;",code: "&#923;",value: "Λ" },
    { name: "&Mu;",code: "&#924;",value: "Μ" },
    { name: "&Nu;",code: "&#925;",value: "Ν" },
    { name: "&Xi;",code: "&#926;",value: "Ξ" },
    { name: "&Omicron;",code: "&#927;",value: "Ο" },
    { name: "&Pi;",code: "&#928;",value: "Π" },
    { name: "&Rho;",code: "&#929;",value: "Ρ" },
    { name: "&Sigma;",code: "&#931;",value: "Σ" },
    { name: "&Tau;",code: "&#932;",value: "Τ" },
    { name: "&Upsilon;",code: "&#933;",value: "Υ" },
    { name: "&Phi;",code: "&#934;",value: "Φ" },
    { name: "&Chi;",code: "&#935;",value: "Χ" },
    { name: "&Psi;",code: "&#936;",value: "Ψ" },
    { name: "&Omega;",code: "&#937;",value: "Ω" },
    { name: "&alpha;",code: "&#945;",value: "α" },
    { name: "&beta;",code: "&#946;",value: "β" },
    { name: "&gamma;",code: "&#947;",value: "γ" },
    { name: "&delta;",code: "&#948;",value: "δ" },
    { name: "&epsilon;",code: "&#949;",value: "ε" },
    { name: "&zeta;",code: "&#950;",value: "ζ" },
    { name: "&eta;",code: "&#951;",value: "η" },
    { name: "&theta;",code: "&#952;",value: "θ" },
    { name: "&iota;",code: "&#953;",value: "ι" },
    { name: "&kappa;",code: "&#954;",value: "κ" },
    { name: "&lambda;",code: "&#955;",value: "λ" },
    { name: "&mu;",code: "&#956;",value: "μ" },
    { name: "&nu;",code: "&#957;",value: "ν" },
    { name: "&xi;",code: "&#958;",value: "ξ" },
    { name: "&omicron;",code: "&#959;",value: "ο" },
    { name: "&pi;",code: "&#960;",value: "π" },
    { name: "&rho;",code: "&#961;",value: "ρ" },
    { name: "&sigmaf;",code: "&#962;",value: "ς" },
    { name: "&sigma;",code: "&#963;",value: "σ" },
    { name: "&tau;",code: "&#964;",value: "τ" },
    { name: "&upsilon;",code: "&#965;",value: "υ" },
    { name: "&phi;",code: "&#966;",value: "φ" },
    { name: "&chi;",code: "&#967;",value: "χ" },
    { name: "&psi;",code: "&#968;",value: "ψ" },
    { name: "&omega;",code: "&#969;",value: "ω" },
    { name: "&larr;",code: "&#8592;",value: "←" },
    { name: "&uarr;",code: "&#8593;",value: "↑" },
    { name: "&rarr;",code: "&#8594;",value: "→" },
    { name: "&darr;",code: "&#8595;",value: "↓" },
    { name: "&harr;",code: "&#8596;",value: "↔" },
    { name: "&spades;",code: "&#9824;",value: "♠" },
    { name: "&clubs;",code: "&#9827;",value: "♣" },
    { name: "&hearts;",code: "&#9829;",value: "♥" },
    { name: "&diams;",code: "&#9830;",value: "♦" },
    { name: "&quot;",code: "&#34;",value: "\"" },
    { name: "&amp;",code: "&#38;",value: "&" },
    { name: "&lt;",code: "&#60;",value: "<" },
    { name: "&gt;",code: "&#62;",value: ">" },
    { name: "&hellip;",code: "&#8230;",value: "…" },
    { name: "&prime;",code: "&#8242;",value: "′" },
    { name: "&Prime;",code: "&#8243;",value: "″" },
    { name: "&ndash;",code: "&#8211;",value: "–" },
    { name: "&mdash;",code: "&#8212;",value: "—" },
    { name: "&lsquo;",code: "&#8216;",value: "‘" },
    { name: "&rsquo;",code: "&#8217;",value: "’" },
    { name: "&sbquo;",code: "&#8218;",value: "‚" },
    { name: "&ldquo;",code: "&#8220;",value: "“" },
    { name: "&rdquo;",code: "&#8221;",value: "”" },
    { name: "&bdquo;",code: "&#8222;",value: "„" },
    { name: "&laquo;",code: "&#171;",value: "«" },
    { name: "&raquo;",code: "&#187;",value: "»" }
];

export const htmlCodesByCode = {};
export const htmlCodesByName = {};

for (let i = 0, n = htmlCodes.length; i < n; i++) {
    htmlCodesByCode[htmlCodes[i].code] = htmlCodes[i];
    htmlCodesByName[htmlCodes[i].name] = htmlCodes[i];
}

export function getHtmlCodeValue(code) {
    return htmlCodesByName[code] || htmlCodesByCode[code];
}

export function stripTags(html) {
    if ( !isString(html) ) {
        return "";
    }

    return html
        .replace(/<br[^>]*>/gi, "\n")
        .replace(/<[^>]*>/g, "")
        .replace(/&#?\w+;/g, function(code) {
            code = getHtmlCodeValue(code);
            if ( code ) {
                return code.value;
            } else {
                return arguments[0];
            }
        })
    ;
}

export function stripXssTags(html) {
    html = html.replace(/<(script|style|link|iframe|meta|frame|embed)/gi, "");
    return html;
}

// http://stackoverflow.com/questions/1787322/htmlspecialchars-equivalent-in-javascript
export function escapeHtml(text) {
    return ((text || "") + "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}


export function aboutBrow() {
    let brow = navigator.vendor === "" ? "Firefox" : (
        isString(navigator.vendor)
            ? navigator.vendor.split(" ")[0]
            : "Internet Explorer"
    );
    let platform = navigator.platform || "";
    let screenW = screen.availWidth;
    let screenH = screen.availHeight;
    let vers = navigator.appVersion && navigator.appVersion.toLowerCase();
    let fullData = "";

    if ( brow == "Google" && isObject(window.opr) ) {
        brow = "Opera";
    }

    if ( isFunction(window.msClearImmediate) ) {
        brow = "Internet Explorer";
        vers = "11.0";
    } else {
        try {
            vers = ({
                "opera"() { return vers.split("opr/")[1]; },
                "firefox"() { return vers.split(" ")[0]; },
                "internet explorer"() { return vers.split("msie ")[1].split(";")[0]; },
                "apple"() { return vers.split("version/")[1]; },
                "google"() { return vers.split("chrome/")[1].split(" ")[0]; }
            })[brow.toLowerCase()]();
        } catch ( e ) {
            brow = "unknown";
            vers = "unknow";
            fullData = "\n\r" + navigator.vendor + "; " + navigator.platform + ";" + navigator.appVersion;
        }
    }


    let isIphone = platform.toLowerCase().indexOf("iphone") != -1 || navigator.userAgent.indexOf("iPhone") != -1;
    let isPad = platform.toLowerCase().indexOf("iphone") != -1 || navigator.userAgent.indexOf("iPad") != -1;
    let isArm = platform.toLowerCase().indexOf("arm") != -1 || navigator.userAgent.indexOf("Android") != -1;
    let isMobile = isIphone || isPad || isArm;

    return {
        brow,
        platform,
        screenW,
        screenH,
        isIphone,
        isPad,
        isArm,
        isMobile,
        isApple: brow.toLowerCase() == "apple",
        vers,
        toString() {
            return "Browser: " + brow + ", Version: " + vers + ", Platform: " + platform + ", Screen: " + screenW + " X " + screenH + fullData;
        }
    };
}


// на входе может быть строка, dom-element, jquery-объект
// иначе ошибка
// на выходе jquery-объект
export function checkElem($el) {
    if ( $el == null ) {
        return window.$("<div/>");
    }
    if ( isString($el) || $el instanceof Element || classOf($el) == "HTMLDocument" ) {
        $el = window.$($el);
    }
    else if ( !($el instanceof window.$) ) {
        throw new Error("bad elem", $el);
    }
    return $el;
}

export function checkElemIn($el, $wrapper) {
    $el = checkElem($el);
    if ( $wrapper instanceof window.constructor ) { // Window undefined in safari
        $wrapper = window.$($wrapper.document.body);
    } else {
        $wrapper = checkElem($wrapper);
    }
    let el = $el.get(0);
    let wrapper = $wrapper.get(0);

    if ( wrapper == el ) {
        return true;
    }

    let body = document.body;
    if ( wrapper != body && el == body ) {
        return false;
    }

    let parent = el && el.parentNode;
    while ( parent && parent != body && parent != wrapper ) {
        parent = parent.parentNode;
    }

    return parent == wrapper;
}

export function getWheelDelta(e) {
    e = e.originalEvent || e;
    if ( "deltaY" in e ) {
        return e.deltaY;
    }
    if ( "detail" in e ) {
        return e.detail;
    }
    if ( "wheelDelta" in e ) {
        return (-1 / 3 * e.wheelDelta);
    }
    return 0;
}

export function downloadFile(sUrl, options = { query: false }, originalFileName) {
    sUrl = sUrl.replace("\\", "/");
    let fileName = sUrl.substring(sUrl.lastIndexOf("/") + 1, sUrl.length);
    let encodedName = encodeURIComponent(fileName);
    let encodedUrl = sUrl
        .split("/")
        .slice(0, -1)
        .concat(encodedName)
        .join("/");
        //Creating new link node.
    let link = document.createElement("a");
    link.href = encodedUrl;

    if ( options && options.query ) {
        encodedUrl += `?${options.query}`;
    }

    if ( originalFileName ) {
        //Set HTML5 download attribute. This will prevent file from opening if supported.
        link.download = originalFileName;
    } else {
        link.download = fileName;
    }

    //Dispatching click event.
    if ( document.createEvent ) {
        let e = document.createEvent("MouseEvents");
        if ( aboutBrow().brow == "Internet Explorer" ) {
            link.target = "_blank";
            document.body.appendChild(link);
            e.initEvent("click" ,true ,true);
            link.dispatchEvent(e);
            link.outerHTML = "";
        } else {
            e.initEvent("click" ,true ,true);
            link.dispatchEvent(e);
        }

        return true;
    } else {
        window.open(encodedUrl, "_blank");
    }
}

// функция нужна, что бы во время drag'n'drop находить
// элементы под перемещаемым объектом
export function getCurrentTarget(e) {
    let point = getMousePoint(e);
    return document.elementFromPoint(point.x, point.y);
}

let _browserSupportTransform = null;
export function browserSupportTransform() {
    if ( _browserSupportTransform === null ) {
        _browserSupportTransform = (
            "transform" in document.body.style
        );
    }

    return _browserSupportTransform;
}

export function drawTopLeft(el, x, y) {
    if ( browserSupportTransform() ) {
        // дробное значние x или y приводит к размытию текста
        el.style.transform = `translate( ${ Math.floor(x) }px, ${ Math.floor(y) }px )`;
    } else {
        el.style.left = x + "px";
        el.style.top = y + "px";
    }
}

export function copy2clipboard(text) {
    if ( typeof document == "undefined" ) {
        return;
    }

    if ( window.clipboardData ) { // IE
        window.clipboardData.setData("text", text);
    } else { // Other
        let elem = document.createElement("div");
        elem.style.visibility = "hidden";
        elem.style.position = "absolute";
        elem.style.top = "-999999px";
        elem.style.left = "-999999px";
        elem.style.color = "black";
        elem.style.backgroundColor = "transparent";
        elem.style.fontSize = "12px";
        //elem.contentEditable = true; // Mozilla
        //document.designMode = 'On';
        elem.id = "js-clipboard-copy-elem-" + Date.now();
        document.body.appendChild(elem);
        elem = document.getElementById(elem.id);

        elem.innerHTML = text;
        elem.style.visibility = "visible";

        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNodeContents(elem);
        window.getSelection().addRange(range);

        document.execCommand("copy");

        elem.innerHTML = "";
    }
}

export function findBehavior(regionOrView, BehaviorClass) {
    const isRegion = regionOrView && regionOrView.hasView;
    const view = isRegion ? regionOrView.currentView : regionOrView;

    const allBehaviors = view && view._behaviors || [];
    const someBehavior = allBehaviors.find((behavior) =>
        behavior instanceof BehaviorClass
    );
    return someBehavior;
}

export function findItemViewByEvent(collectionView, domEvent) {
    const $target = $(domEvent.target);
    const $contact = (
        $target.hasClass(collectionView.childView.className)
            ? $target
            : $target.parents("." + collectionView.childView.className)
    );
    const modelId = $contact.attr("data-model-id");
    const itemView = collectionView.children.find((itemView) =>
        itemView.model.id == modelId
    );
    return itemView;
}
